import { apiClient } from './api';

export interface UserProfile {
  id: string;
  companyName: string;
  companyWebsite?: string;
  practiceArea: string;
  practiceAreaOther?: string;
  companySize: string;
  position: string;
  phone?: string;
  referralSources: string[];
  tosAcceptedAt: string;
  subscribedToUpdates: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface ProfileSubmissionData {
  companyName: string;
  companyWebsite?: string;
  practiceArea: string;
  practiceAreaOther?: string;
  companySize: string;
  position: string;
  phone?: string;
  referralSources: string[];
  tosAcceptedAt: string;
  subscribedToUpdates: boolean;
}

export interface ProfileResponse {
  data: UserProfile;
}

class ProfileService {
  async getProfile(): Promise<UserProfile | null> {
    try {
      const response = await apiClient.get<ProfileResponse>('/profile');
      return response.data.data;
    } catch (error: any) {
      if (error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  }

  async updateProfile(
    profileData: ProfileSubmissionData
  ): Promise<UserProfile> {
    const response = await apiClient.patch<ProfileResponse>('/profile', {
      user_profile: {
        company_name: profileData.companyName,
        company_website: profileData.companyWebsite,
        practice_area: profileData.practiceArea,
        practice_area_other:
          profileData.practiceArea === 'Other'
            ? profileData.practiceAreaOther
            : undefined,
        company_size: profileData.companySize,
        position: profileData.position,
        phone: profileData.phone,
        referral_sources: profileData.referralSources,
        tos_accepted_at: profileData.tosAcceptedAt,
        subscribed_to_updates: profileData.subscribedToUpdates,
      },
    });

    return response.data.data;
  }
}

export const profileService = new ProfileService();
export default profileService;
